module.exports = __webpack_public_path__ + "media/images/riders/MAJA_WLOSZCZOWSKA-4215804ba7e8424acc5b3d37f47ebe28.png";